import IconButton from 'components/atoms/button/IconButton'
import Headline from 'components/atoms/headline/Headline'
import Icon from 'components/atoms/icon/Icon'
import TabsSwitch from 'components/molecules/tabs/TabsSwitch'
import { IconType } from 'lib/helpers/constants/iconTypes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Leaves from './requests-tabs/leaves/Leaves'
import Orders from './requests-tabs/orders/Orders'
import CreateLeaveRequest from './requests-tabs/leaves/create-leave-request/CreateLeaveRequest'
import { useLeaveRequests } from 'lib/hooks/queries/Employee/useLeaveRequests'
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen'
import CreateOrderRequest from './requests-tabs/orders/create-order-request/CreateOrderRequest'
import { useOrderRequests } from 'lib/hooks/queries/Employee/useOrderRequests'
import { useParams } from 'react-router-dom'
import { usePermissions } from 'lib/hooks/shared/usePermissions'
import ConditionalRender from 'components/atoms/conditional-render/ConditionalRender'

const Requests = () => {

    const { t } = useTranslation()

    const [selectedTabSwitch, setSelectedTabSwitch] = useState<number>(0);
    const [OpenModal, setIsModalOpen] = useState('')

    const {id} = useParams()

    const { data: leaveRequests, isLoading: LeaveRequestsLoading } = useLeaveRequests({id: id})

    const { data: orderRequests, isLoading: OrderRequestsLoading } = useOrderRequests({id: id})

    const hasPermissionToCreateAbsence = usePermissions(['absence_requests_create'])
    const hasPermissionToCreateOrders = usePermissions(['orders_request_create'])


    const hasPermissionToViewAbsence = usePermissions(['absence_requests_view'])
    const hasPermissionToViewOwnAbsence = usePermissions(['absence_requests_view_view_own'])

    const hasPermissionToViewOrders = usePermissions(['orders_request_view'])
    const hasPermissionToViewOwnOrders = usePermissions(['orders_request_view_view_own'])

    const tabs = [
        {
            id: 0,
            name: "Leaves",
            show: hasPermissionToViewAbsence || hasPermissionToViewOwnAbsence
        },
        {
            id: 1,
            name: "Orders",
            show: hasPermissionToViewOrders || hasPermissionToViewOwnOrders
        },
    ].filter(tab => tab.show);

    return (
        <div>
            <div className='flex items-center justify-between mb-[15px] gap-4'>
                <Headline title={t("Requests")} className="!mt-0 !mb-[0px]" />
                {{
                    0: (
                        <ConditionalRender condition={hasPermissionToCreateAbsence}>
                            <IconButton
                                icon={<Icon iconType={IconType.PLUS_ICON} />}
                                onClick={() => { setIsModalOpen('Leave') }}
                            >
                                {t('Create Leave Request')}
                            </IconButton>
                        </ConditionalRender>
                    ),
                    1: (
                        <ConditionalRender condition={hasPermissionToCreateOrders}>
                            <IconButton icon={<Icon iconType={IconType.PLUS_ICON} />}
                                onClick={() => { setIsModalOpen('Order') }}
                            >
                                {t('Create Order')}
                            </IconButton>
                        </ConditionalRender>
                    ),
                }[selectedTabSwitch]}
            </div>
            <TabsSwitch
                ActiveTab={selectedTabSwitch}
                setSelectedTab={(id) => setSelectedTabSwitch(id)}
                classes={{
                    iconAndTextWrapperClass:
                        "text-[13px] lg:text-[14px] xl:text-[16px] flex items-center",
                    text: "!px-0 !pb-[8px]",
                    unActiveTabClass: "!px-0 !pb-[8px] w-full",
                    tabsClass: 'gap-5'
                }}
                tabs={tabs}
            />

            {(LeaveRequestsLoading || OrderRequestsLoading) ? (
                <div className="relative py-16">
                    <LoadingScreen />
                </div>
            ) : (
                {
                    0: <Leaves data={leaveRequests} />,
                    1: <Orders data={orderRequests} />,
                }[selectedTabSwitch]
            )}
            <CreateLeaveRequest
                hocisOpen={OpenModal === 'Leave'}
                hocToggleModal={() => { setIsModalOpen('') }}
                hocCurrentStep={1}
                hocTitle='Create Leave Request'
                hocClasses={{
                    modalClassName: 'w-full sm:max-w-[550px]',
                }}
                onConfirm={() => { setIsModalOpen('') }}
            />

            <CreateOrderRequest
                hocisOpen={OpenModal === 'Order'}
                hocToggleModal={() => { setIsModalOpen('') }}
                hocCurrentStep={1}
                hocTitle='Create Order Request'
                hocClasses={{
                    modalClassName: 'w-full sm:max-w-[550px]',
                }}
                onConfirm={() => { setIsModalOpen('') }}
            />
        </div>
    )
}

export default Requests